/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable react/jsx-wrap-multilines */
import React, { useEffect } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { submit } from 'redux-form';
import { useHistory, useLocation } from 'react-router';
import PropTypes from 'prop-types';
import { useInjectSaga } from '../../utils/injectSaga';
import saga from './saga';
import { useInjectReducer } from '../../utils/injectReducer';
import reducer from './reducer';
import { ModalWindow } from '../../semantic-ui/components/modal-window';
import ModalFooterButtons from '../../semantic-ui/components/modal-window/modal-footer-buttons';
import { LegalModalContent } from './components/legal-modal-content';
import {
	createLegalAction,
	deleteLegalAction,
	getLegalInfoAction,
	resetStateAction,
	setLegalSearchValueAction,
	setLegalsOptionsAction,
	updateLegalAction,
} from './actions';
import {
	getActiveLegalIdSelector,
	getLegalInfoSelector,
	getLegalNameSelector,
	getIsLegalAddFormOpenSelector,
	getIsLegalEditFormOpenSelector,
	getIsLegalInfoLoadingSelector,
	getIsModalShownSelector,
	getIsAuditTabShownSelector,
} from './selectors';
import { LEGAL_FORM_NAME } from './constants';
import { getIsAvailableLegalsButtonsSelector } from '../profile/selectors';
import { setWindowInfoAction } from '../alert-modal/actions';
import { Audit } from '../../components/audit';

const LegalModalWrapper = ({
	onGetLegalInfo,
	isLegalInfoLoading,
	isLegalEditFormOpen,
	isLegalAddFormOpen,
	legalInfo,
	legalName,
	onResetState,
	onDeleteLegal,
	isModalShown,
	activeLegalId,
	onCreateLegal,
	onUpdateLegal,
	onFormSubmit,
	onSetLegalSearchValue,
	onSetLegalsOptions,
	isAvailable,
	onSetWindowInfo,
	isAuditTabShown,
}) => {
	useInjectSaga({ key: 'legalModalPageSaga', saga });
	useInjectReducer({ key: 'legalModalReducer', reducer });

	const { search, pathname } = useLocation();

	const query = new URLSearchParams(search);

	const modal = query.get('modal');

	const mode = query.get('mode');

	const history = useHistory();

	useEffect(() => {
		return () => onResetState();
	}, []);

	useEffect(() => {
		if (activeLegalId) onGetLegalInfo(activeLegalId);
	}, [activeLegalId]);

	const handleLegalFormOpenButtonClick = mode => {
		if (activeLegalId) {
			query.set('id', activeLegalId);
		} else {
			query.delete('id');
		}

		if (mode === 'edit') {
			query.set('mode', 'edit');
		}

		if (mode === 'cancel') {
			onSetLegalSearchValue('');
			onSetLegalsOptions([]);
			query.delete('mode');
		}

		if (mode === 'cancel' && !activeLegalId) {
			onResetState();
			query.delete('modal');
		}

		history.push(`${pathname}?${query}`);
	};

	const handleModalClose = () => {
		query.delete('modal');
		query.delete('mode');
		query.delete('id');
		query.delete('tab');

		onResetState();
		history.push(`${pathname}?${query}`);
	};

	const handleLegalDelete = () => {
		onSetWindowInfo({
			type: 'delete',
			title: 'Вы уверены?',
			text: 'Вы не сможете это отменить',
			button: {
				type: 'success',
				text: 'Да, удалить',
				onClick: () => onDeleteLegal({ id: activeLegalId, redirect: handleModalClose, query }),
			},
		});
	};

	const handleLegalFormSubmit = async () => {
		await onFormSubmit(LEGAL_FORM_NAME);

		if (activeLegalId) {
			onUpdateLegal({
				id: activeLegalId,
				searchQuery: query.toString(),
				redirect: history.push,
			});
			return;
		}

		onCreateLegal({ redirect: history.push, resetState: onResetState, searchQuery: query.toString() });
	};

	const handleKeyDown = e => {
		if (e.key === 'Enter' && e.shiftKey === false) {
			handleLegalFormSubmit();
		}
	};

	const handleNavItemClick = modal => {
		query.delete('tab');
		query.set('modal', modal === 'audit' ? 'legal' : modal);

		if (mode) {
			query.delete('mode');
		}

		if (modal === 'audit') {
			query.set('tab', 'audit');
		}

		history.push(`${pathname}?${query}`);
	};

	return (
		<ModalWindow
			isModalShown={isModalShown}
			onKeyDown={handleKeyDown}
			onClose={handleModalClose}
			headerText={
				isLegalEditFormOpen || isLegalAddFormOpen
					? `${isLegalEditFormOpen ? 'Изменить юр. лицо' : 'Создать юр. лицо'}`
					: legalName
			}
			navItems={
				isLegalEditFormOpen || isLegalAddFormOpen
					? []
					: [
							{
								id: 'info',
								text: 'Информация',
								onClick: () => handleNavItemClick('legal'),
								isActive: modal === 'legal' && !isAuditTabShown,
							},
							{
								id: 'audit',
								text: 'Изменения',
								onClick: () => handleNavItemClick('audit'),
								isActive: modal === 'legal' && isAuditTabShown,
							},
					  ]
			}
			modalContent={
				!isAuditTabShown ? (
					<LegalModalContent
						legalInfo={legalInfo}
						isLegalInfoLoading={isLegalInfoLoading}
						isLegalFormOpen={isLegalEditFormOpen || isLegalAddFormOpen}
					/>
				) : (
					<Audit entityName="legals" entityId={activeLegalId} />
				)
			}
			style={{ width: '895px' }}
			actionButtons={[{ type: 'close', onClick: handleModalClose, text: 'legal' }]}
			footerButtons={
				<ModalFooterButtons
					leftButtons={
						!(isLegalEditFormOpen || isLegalAddFormOpen) && isAvailable.delete && !isAuditTabShown
							? [
									{
										onClick: handleLegalDelete,
										text: 'Удалить',
										color: 'warning',
										disabled: isLegalInfoLoading,
									},
							  ]
							: []
					}
					rightButtons={
						isLegalEditFormOpen || isLegalAddFormOpen
							? [
									{
										onClick: handleLegalFormSubmit,
										text: 'Сохранить',
										color: 'primary',
										loading: isLegalInfoLoading,
										disabled: isLegalInfoLoading,
									},
									{
										onClick: () => handleLegalFormOpenButtonClick('cancel'),
										text: 'Отмена',
										color: 'secondary',
										disabled: isLegalInfoLoading,
									},
							  ]
							: [
									...(isAvailable.update && !isAuditTabShown
										? [
												{
													onClick: () => handleLegalFormOpenButtonClick('edit'),
													text: 'Изменить',
													color: 'primary',
													disabled: isLegalInfoLoading,
												},
										  ]
										: []),
									{
										onClick: handleModalClose,
										text: 'Закрыть',
										color: 'secondary',
									},
							  ]
					}
				/>
			}
		/>
	);
};

const mapStateToProps = createStructuredSelector({
	legalInfo: getLegalInfoSelector(),
	isLegalInfoLoading: getIsLegalInfoLoadingSelector(),
	isLegalAddFormOpen: getIsLegalAddFormOpenSelector(),
	isLegalEditFormOpen: getIsLegalEditFormOpenSelector(),
	legalName: getLegalNameSelector(),
	isModalShown: getIsModalShownSelector(),
	activeLegalId: getActiveLegalIdSelector(),
	isAvailable: getIsAvailableLegalsButtonsSelector(),
	isAuditTabShown: getIsAuditTabShownSelector(),
});

const mapDispatchToProps = {
	onGetLegalInfo: getLegalInfoAction,
	onDeleteLegal: deleteLegalAction,
	onResetState: resetStateAction,
	onCreateLegal: createLegalAction,
	onUpdateLegal: updateLegalAction,
	onFormSubmit: submit,
	onSetLegalSearchValue: setLegalSearchValueAction,
	onSetLegalsOptions: setLegalsOptionsAction,
	onSetWindowInfo: setWindowInfoAction,
};

const LegalModal = connect(mapStateToProps, mapDispatchToProps)(LegalModalWrapper);

LegalModalWrapper.propTypes = {
	onGetLegalInfo: PropTypes.func.isRequired,
	legalInfo: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string.isRequired,
			value: PropTypes.oneOfType([PropTypes.string, PropTypes.objectOf(PropTypes.string)]).isRequired,
		}),
	),
	isLegalInfoLoading: PropTypes.bool.isRequired,
	isLegalEditFormOpen: PropTypes.bool.isRequired,
	isLegalAddFormOpen: PropTypes.bool.isRequired,
	legalName: PropTypes.string.isRequired,
	onDeleteLegal: PropTypes.func.isRequired,
	onResetState: PropTypes.func.isRequired,
	isModalShown: PropTypes.bool.isRequired,
	activeLegalId: PropTypes.string,
	onCreateLegal: PropTypes.func.isRequired,
	onUpdateLegal: PropTypes.func.isRequired,
	onFormSubmit: PropTypes.func.isRequired,
	onSetLegalSearchValue: PropTypes.func.isRequired,
	onSetLegalsOptions: PropTypes.func.isRequired,
	isAvailable: PropTypes.objectOf(PropTypes.bool),
	onSetWindowInfo: PropTypes.func.isRequired,
	isAuditTabShown: PropTypes.bool.isRequired,
};

export default LegalModal;
